import api from '@/utils/http/axios'
import store from '@/store'
// import { NO_PREFIX_URL } from '@/utils/http/base-url'
export default {
  /**
  * 根据银行卡号查询银行
  */
  getBankNameByCardNo (params = {}, config = {}) {
    return api.post('/api/msbc/bankInfoAttr', params, config, 'FormData')
  },
  /**
   * @desc 获取各国家手机区号
  */
  getCountryAreaCodeList (params = {}, config = {}) {
    return api.get(`/api/pub/countryCode?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * @desc 通知收款方
   * @param {object} params
   * @param {'RECV_REPORT' | 'TRANSFER_OUT'} params.bizType  业务代码  RECV_REPORT （收款申报）,TRANSFER_OUT (转账)
   * @param {string} params.countryCode 国码
   * @param {string} params.email 邮箱
   * @param {string} params.flowNo 交易单号
   * @param {string} params.phone 手机号
  */
  noticyPayee (params = {}, config = {}) {
    return api.post(`api/opposite/info/save?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config, 'FormData')
  }
}
